import axios, { CreateAxiosDefaults } from 'axios';
import { isDev } from 'constant';

axios.defaults.baseURL = process.env.REACT_APP_USERSRV_URL;
axios.defaults.withCredentials = true;

export const axiosInstanceGenerator = (config: CreateAxiosDefaults) => {
  const axiosInstance = axios.create(config);
  axiosInstance.interceptors.response.use(
    (res) => res,
    (err) => {
      const isNoAuth = err?.response?.status === 401;
      const isNoPermission = err?.response?.status === 403;

      if (isNoAuth || isNoPermission) {
        const fromPath = window.location.pathname + window.location.search;

        localStorage.setItem('servertools-from-path', fromPath);
        isDev
          ? window.location.replace(isNoAuth ? '/login' : '/no-permission')
          : window.location.replace(
              isNoAuth
                ? process.env.REACT_APP_USERSRV_URL + '/auth?sso'
                : '/no-permission'
            );

        // return;
      }

      return Promise.reject(err);
    }
  );

  return axiosInstance;
};

export const axiosInstance = axiosInstanceGenerator({});
